export const handleChangeDataHistoryChatPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_HISTORY_CHAT', name, value
});